import { getIsPostRatingEnabled } from '../../../common/selectors/app-settings-selectors';
import { updatePostsRatings } from '../../../common/store/post-ratings/post-ratings-actions';
import type { AppStore, ControllerConfig, FlowAPI } from '../../../common/types';

type Params = {
  controllerConfig: ControllerConfig;
  store: AppStore;
  flowAPI: FlowAPI;
  loadSSR?: boolean;
  resourceId?: string;
};

export async function initWixCommentsController({
  controllerConfig,
  store,
  flowAPI,
  loadSSR,
  resourceId,
}: Params) {
  const initializeCommentsController = (
    await import(/* webpackChunkName: "wix-comments-controller" */ './wix-comments-controller')
  ).default;

  const { wixCommentsApi } = await initializeCommentsController({
    controllerConfig,
    httpClient: flowAPI.httpClient,
    errorHandler: flowAPI.errorHandler,
    loadSSR: !!loadSSR,
  });

  if (loadSSR) {
    if (!resourceId) {
      return wixCommentsApi;
    }

    // fetchComments returns a promise (not void).
    (await wixCommentsApi.fetchComments({
      resourceId,
      ctxFields: {
        contextId: resourceId,
        contextType: 'postId',
      },
    })) as unknown as Promise<void>;

    // bindStateToSetProps returns a promise (not void).
    (await wixCommentsApi.bindStateToSetProps()) as unknown as Promise<void>;

    if (getIsPostRatingEnabled(store?.getState?.())) {
      wixCommentsApi.watch.ratings.onChange((newState) => {
        store.dispatch(updatePostsRatings(newState));
      });
    }
  } else {
    const state = store.getState();
    const withRatings = getIsPostRatingEnabled(state);

    if (withRatings) {
      wixCommentsApi.watch.ratings.onChange((newState) => {
        store.dispatch(updatePostsRatings(newState));
      });
    }
  }

  return wixCommentsApi;
}
